



























import { defineComponent, ref } from "@vue/composition-api";
import { PersonalInformation } from "@scrile/api-provider/dist/api/PersonalInformationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import BaseInput from "@/components/BaseInput";
import { personalInfoFields } from "../config";

export default defineComponent({
  name: "PersonalInfoForm",
  components: { BaseInput, BaseForm },
  setup(_, { emit }) {
    const { authUserStrict } = useAuthUser();
    const personalInformation = ref<PersonalInformation | null>(null);
    const values = ref<FormValues>({
      firstName: "",
      lastName: "",
      phone: "",
      instagram: "",
    });

    const getData = async () => {
      personalInformation.value = await providers.PersonalInformationProvider.find({ id: authUserStrict.value.id });
      values.value = {
        firstName: personalInformation.value.firstName,
        lastName: personalInformation.value.lastName,
        phone: personalInformation.value.phone,
        instagram: personalInformation.value.instagram,
      };
    };

    const submitPersonalInfo = async () => {
      const data = {
        userId: authUserStrict.value.id,
        firstName: values.value.firstName,
        lastName: values.value.lastName,
        phone: values.value.phone,
        instagram: values.value.instagram,
      };
      personalInformation.value = await providers.PersonalInformationProvider.update({ data });
      values.value = {
        ...values.value,
        firstName: personalInformation.value.firstName,
        lastName: personalInformation.value.lastName,
        phone: personalInformation.value.phone,
        instagram: personalInformation.value.instagram,
      };
    };

    const created = async () => {
      emit("setValid", true);
      emit("setCb", () => submitPersonalInfo());
      try {
        emit("setLoading", true);
        await getData();
      } finally {
        emit("setLoading", false);
      }
    };

    created();

    return {
      values,
      personalInfoFields,
    };
  },
});
